// extracted by mini-css-extract-plugin
export default {"progress":"Fetching_progress__X8h6W"};